import type { FC } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { Card } from "@jti/core-components/components/Card";
import { PointsBlock, useTranslations } from "@jti/ui";

import styles from "./CartPoints.module.scss";

type CartPointsProps = {
  totalPointsCount: number;
};

export const CartPoints: FC<CartPointsProps> = ({ totalPointsCount }) => {
  const { __ } = useTranslations();
  const { LOYALTY_KNOW_MORE_URL } = useConfig();

  return (
    <Card variant="level-2">
      <div className={styles.reward}>{`${__("loyalty.pointsBlock.title", undefined, "Ploom Club")} ${__(
        "cart.ploom_club.reward"
      )}`}</div>
      <PointsBlock
        hasLogo={false}
        knowMoreUrl={LOYALTY_KNOW_MORE_URL}
        urlText={__("cart.ploom_club.pointsBlock.link")}
        points={totalPointsCount}
        pointsLabel={__("cart.ploom_club.points")}
        text={__("cart.ploom_club.pointsBlock.message", [totalPointsCount])}
      />
    </Card>
  );
};
